import { ideaStepFluxConstants } from '../constants';
import { ideaStepFluxService } from '../services';
import { alertActions } from './alert.actions';
import { history } from '../helpers';

export const ideaStepFluxActions = {
  createIdeaStepFlux,
  deleteStepFlux,
  editIdeaStepFlux,
  setIdeaStepFluxData,
  clearIdeaStepFluxData,
  setNewContent,
  setNewContentSwitch,
  setDecisionName,
  setEvaluationLevel,
  setNotificationControls,
  loadStepDetails,
}

function createIdeaStepFlux(ideaStepFlux) {

  return async dispatch => {
    dispatch({ type: ideaStepFluxConstants.CREATE_IDEA_STEP_FLUX_REQUEST });

    try {
      await ideaStepFluxService.createIdeaStepFlux(ideaStepFlux);
      dispatch({ type: ideaStepFluxConstants.CREATE_IDEA_STEP_FLUX_SUCCESS });
      dispatch(alertActions.success('Etapa criada com sucesso!'));
      clearIdeaStepFluxData()
      history.push('/preferences/flux-of-ideas');
    } catch(error) {

      dispatch({
        type: ideaStepFluxConstants.CREATE_IDEA_STEP_FLUX_FAILURE,
        error: error.toString()
      });
      dispatch(alertActions.error('tente novamente'));
    }
  }
}

function editIdeaStepFlux(ideaStepFlux) {

  return async dispatch => {
    dispatch({ type: ideaStepFluxConstants.EDIT_IDEA_STEP_FLUX_REQUEST });

    try {
      await ideaStepFluxService.editIdeaStepFlux(ideaStepFlux);
      dispatch({ type: ideaStepFluxConstants.EDIT_IDEA_STEP_FLUX_SUCCESS });
      dispatch(alertActions.success('Etapa alterada com sucesso!'));
      clearIdeaStepFluxData();
      history.push('/preferences/flux-of-ideas');
    } catch(error) {

      dispatch({
        type: ideaStepFluxConstants.EDIT_IDEA_STEP_FLUX_FAILURE,
        error: error.toString()
      });
      dispatch(alertActions.error('tente novamente'));
    }
  }
}

function deleteStepFlux(_id) {
  return async dispatch => {
    dispatch({ type: ideaStepFluxConstants.DELETE_IDEA_STEP_FLUX_REQUEST });

    try {
      await ideaStepFluxService.removeIdeaStepFlux(_id);
      dispatch({ type: ideaStepFluxConstants.DELETE_IDEA_STEP_FLUX_SUCCESS });
      dispatch(alertActions.success('Etapa excluída com sucesso!'));
      clearIdeaStepFluxData()
      history.push('/');
    } catch(error) {

      dispatch({
        type: ideaStepFluxConstants.DELETE_IDEA_STEP_FLUX_FAILURE,
        error: error.toString()
      });
      dispatch(alertActions.error('tente novamente'));
    }
  }
}

function setIdeaStepFluxData(ideaStepFlux) {
  return async dispatch => {
    dispatch({ type: ideaStepFluxConstants.SET_IDEA_STEP_FLUX_DATA, payload: ideaStepFlux })
  }
}

function setNewContent({ name, value }) {
  return (dispatch) => {
    dispatch({ type: ideaStepFluxConstants.SET_NEW_CONTENT, payload: { name, value } });
  }
}

function setDecisionName({ typeDecision, value }) {
  return (dispatch) => {
    dispatch({ type: ideaStepFluxConstants.SET_DECISION_NAME, payload: { typeDecision, value } });
  }
}

function setEvaluationLevel({ name, checked }) {
  return (dispatch) => {
    dispatch({ type: ideaStepFluxConstants.SET_EVALUATION_LEVEL, payload: { name, checked } });
  }
}

function setNotificationControls({ name, checked }) {
  return (dispatch) => {
    dispatch({ type: ideaStepFluxConstants.SET_NOTIFICAITON_LEVEL, payload: { name, checked } });
  }
}

function setNewContentSwitch({ name, checked }) {
  return (dispatch) => {
    dispatch({ type: ideaStepFluxConstants.SET_NEW_CONTENT_SWITCH, payload: { name, checked } });
  }
}

function clearIdeaStepFluxData() {
  return async dispatch => {
    dispatch({ type: ideaStepFluxConstants.CLEAR_IDEA_STEP_FLUX_DATA })
  }
}

function loadStepDetails(data) {
  return dispatch => {
    dispatch({
      type: ideaStepFluxConstants.LOAD_STEP_DETAILS,
      payload: data
    });
  }
}